import { render, staticRenderFns } from "./SuperiorInfoDlg.vue?vue&type=template&id=8e03d16c&scoped=true"
import script from "./SuperiorInfoDlg.vue?vue&type=script&lang=js"
export * from "./SuperiorInfoDlg.vue?vue&type=script&lang=js"
import style0 from "./SuperiorInfoDlg.vue?vue&type=style&index=0&id=8e03d16c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e03d16c",
  null
  
)

export default component.exports